import type { PageRef } from '@wix/editor-platform-sdk-types'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { getPatternDefForPage } from '../router-config/routerConfig'
import type { RouterConfig } from '../router-config/routerConfigTypes'
import { buildUrl } from './utils'

export const getRoutingUrlByPageRef = async (
  editorSdkProxy: EditorSDK,
  pageRef: PageRef,
): Promise<string> => {
  const routerRef = await editorSdkProxy.routers.getByPage({ pageRef })
  const routerData = await editorSdkProxy.routers.get<RouterConfig>({
    routerRef,
  })

  const { pattern } = getPatternDefForPage(
    routerData.config,
    routerData.pages,
    pageRef,
  )

  return buildUrl(routerData.prefix, pattern)
}
